const codeToken = ({
  mcpServerUrl,
  faradayInstanceUrl
}) => {
  return `claude mcp add --transport http faraday ${mcpServerUrl} \\
--header "X-Faraday-URL: ${faradayInstanceUrl}" \\
--header "X-Faraday-Token: your-api-token"`;
};

const codeUsernamePassword = ({
  mcpServerUrl,
  faradayInstanceUrl
}) => {
  return `claude mcp add --transport http faraday ${mcpServerUrl} \\
--header "X-Faraday-URL: ${faradayInstanceUrl}" \\
--header "X-Faraday-Username: your-username" \\
--header "X-Faraday-Password: your-password"`;
};

const desktopToken = ({
  mcpServerUrl,
  faradayInstanceUrl
}) => {
  return `{
  "mcpServers": {
    "faraday": {
      "type": "http",
      "url": "${mcpServerUrl}",
      "headers": {
        "X-Faraday-URL": "${faradayInstanceUrl}",
        "X-Faraday-Token": "your-api-token"
      }
    }
  }
}`;
};

const desktopUsernamePassword = ({
  mcpServerUrl,
  faradayInstanceUrl
}) => {
  return `{
  "mcpServers": {
    "faraday": {
      "type": "http",
      "url": "${mcpServerUrl}",
      "headers": {
        "X-Faraday-URL": "${faradayInstanceUrl}",
        "X-Faraday-Username": "your-username",
        "X-Faraday-Password": "your-password"
      }
    }
  }
}`;
};

const terminalClients = {
  claudeCode: {
    tokenAuthentication: codeToken,
    usernamePassword: codeUsernamePassword
  },
  claudeDesktop: {
    tokenAuthentication: desktopToken,
    usernamePassword: desktopUsernamePassword
  }
};

export default terminalClients;
